import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

// ── Main component ─────────────────────────────────────────────────────────────

function Footer() {
  const [facebookUrl, setFacebook]   = useState(null);
  const [instagramUrl, setInstagram] = useState(null);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (!element) return;
    const headerHeight = 120;
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerHeight;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  useEffect(() => {
    async function fetchSocialLinks() {
      const { data } = await supabase
        .from('settings')
        .select('key, value')
        .in('key', ['facebook_url', 'instagram_url']);

      (data || []).forEach(row => {
        if (row.key === 'facebook_url')  setFacebook(row.value  || null);
        if (row.key === 'instagram_url') setInstagram(row.value || null);
      });
    }
    fetchSocialLinks();
  }, []);

  return (
    <footer className="w-full bg-navdark py-16 px-6 flex flex-col items-center gap-8">

      {/* Logo */}
      <a href="#top">
        <img
          src="/Assets/Logos/TNL-Horizontal-White&Grey-NoSubheader.png"
          alt="Trivia Nights Live"
          className="h-14 w-auto"
        />
      </a>

      {/* Nav links */}
      <nav className="flex flex-col items-center gap-4 md:flex-row md:items-center md:gap-0 font-poppins text-sm font-semibold tracking-widest">
        <a href="#schedule" onClick={scrollTo('schedule')} className="text-white hover:text-gold transition-colors duration-200 px-4 text-center">
          TRIVIA SCHEDULE
        </a>
        <span className="hidden md:inline text-lightgray">|</span>
        <a href="#contact" onClick={scrollTo('contact')} className="text-white hover:text-gold transition-colors duration-200 px-4 text-center">
          BOOK LOCATION OR EVENT
        </a>
      </nav>

      {/* Social icons — only render links that have a URL */}
      {(facebookUrl || instagramUrl) && (
        <div className="flex items-center gap-3">
          {facebookUrl && (
            <a href={facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-white transition-colors duration-200">
              <FaFacebook size={20} color="#F7941D" />
            </a>
          )}
          {instagramUrl && (
            <a href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-white transition-colors duration-200">
              <FaInstagram size={24} color="#F7941D" />
            </a>
          )}
        </div>
      )}

      {/* Divider */}
      <div className="w-full max-w-md border-t border-lightgray/20" />

      {/* Copyright */}
      <p className="font-poppins text-lightgray text-xs font-light tracking-widest">
        COPYRIGHT &copy;2026 ALL RIGHTS RESERVED
      </p>

    </footer>
  );
}

export default Footer;
